import { ProviderFormData } from 'src/screens/General/screens/Providers/components/ProviderForm';
import { IProviderSend } from '../types/provider';
//Partial<IProvider>
export const provider = (dataForm: ProviderFormData): Partial<IProviderSend> => {
    const {
        serviceLocations,
        serviceTypes,
        providers,
        id,
        rateAdminWork,
        rateAdvance,
        rateAdvanceDate,
        rateAdminWorkDate,
        annualSalary,
        referredByDropDown,
        ...data
    } = dataForm;
    // Partial<IProviderSend>
    const dataSend: AnyObject = {
        ...data,
    };
    const serviceLocationsVal: number[] = [];
    const serviceTypesVal: number[] = [];
    const providersVal: number[] = [];
    if (serviceLocations) {
        serviceLocations.forEach((itData: SelectObject) => {
            serviceLocationsVal.push(+itData.value);
        });
    }

    if (serviceTypes) {
        serviceTypes.forEach((itData: SelectObject) => {
            serviceTypesVal.push(+itData.value);
        });
    }
    if (providers) {
        providers.forEach((itData: SelectObject) => {
            providersVal.push(+itData.value);
        });
    }
    if (id) {
        dataSend.userId = id;
    }
    if (annualSalary) {
        dataSend.annualSalary = +annualSalary;
    }

    dataSend.rateAdvance = rateAdvance ? parseInt(`${rateAdvance}`) : undefined;
    dataSend.rateAdvanceDate = rateAdvanceDate;

    dataSend.rateAdminWork = rateAdminWork ? parseInt(`${rateAdminWork}`) : undefined;
    dataSend.rateAdminWorkDate = rateAdminWorkDate;

    if (referredByDropDown) {
        dataSend.referredBy = referredByDropDown.value;
    }

    delete dataSend.updated;
    delete dataSend.createdAt;
    delete dataSend.created;
    delete dataSend.userServiceLocations;
    delete dataSend.userServiceTypes;
    delete dataSend.rateAdminWorks;
    delete dataSend.rateAdvances;
    delete dataSend.userDocs;
    dataSend.serviceTypes = serviceTypesVal;
    dataSend.providers = providersVal;
    dataSend.serviceLocations = serviceLocationsVal;
    return dataSend;
};
